import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { "data-qa": "delivery-to:UserLocation" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_bar = _resolveComponent("base-bar")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return ($options.isLocationBarVisible)
    ? (_openBlock(), _createBlock(_component_base_bar, {
        key: 0,
        class: "_flexwrap _jc-c _ai-c _tac _py-1",
        "data-qa": "delivery-to:LocationBar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon, {
            class: "_tc--accent _mr-1",
            size: "lg",
            name: "location-dot"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.Resources.Layout.UserLocationModalFieldsetHeading) + ":  ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_1, _toDisplayString($options.currentUserLocation), 1 /* TEXT */),
          ($options.canChangeLocation)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "_tc--accent",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.changeLocation && $options.changeLocation(...args))),
                "data-qa": "delivery-to:ChangeLocation"
              }, _toDisplayString(_ctx.Resources.Layout.UserLocationBoxButtonLabel), 1 /* TEXT */))
            : (_openBlock(), _createBlock(_component_tooltip, {
                key: 1,
                text: _ctx.Resources.Layout.UserLocationBarDisabledDescription,
                "icon-name": "circle-info",
                class: "_ml-1",
                "data-qa": "delivery-to:Tooltip"
              }, null, 8 /* PROPS */, ["text"]))
        ]),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createBlock(_component_skeleton_wrapper, {
        key: 1,
        class: "gfu-bar _py-1 _flexcntr _pos-sticky",
        "data-qa": "delivery-to:Skeleton"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_skeleton_line, {
            height: 26,
            "width-percent": 20
          })
        ]),
        _: 1 /* STABLE */
      }))
}